//Dependencies
import { Button, Form, Input, Loading } from '@gpstrackit/react-controls';
import { Grid, Paper } from '@mui/material';
import { useIntl } from 'react-intl';
//Logos
import logo from 'Assets/images/banner.png';
import google from 'Assets/images/google.svg';
import logoSecundary from 'Assets/images/verticalLogo.png';

//helpers
import {
    ErrorHandlerLogin
} from 'Core/data/Helpers';

import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

//Url's
import { endpoints } from 'Core/defaultValues';
import { ValidateVersion, GerVersionFromServer } from 'Core/security';
//Actions
import { loginForgotPasswordOpenModal, loginRequest } from 'Redux/actions';

//Components
import ForgotPassword from "./.components/forgotPassword";
import ChangePassword from "./.components/chagePassword";
//Styles
import './login.scss';

const currentDomain = window.location.hostname === "localhost" ? `http://localhost:3000` : `https://${window.location.hostname}`;

const LoginView = () => {
    const { messages } = useIntl()
    //Ref
    const formRef = useRef();

    const dispatch = useDispatch();
    const history = useNavigate();
    //Local States
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    //Redux States
    const { loading, error, resultChangePassword } = useSelector(state => state.loginRedux);

    const handleLogin = () => {
        dispatch(loginRequest(username?.trim(), password?.trim(), history));
    }

    useEffect(() => {
        GerVersionFromServer(() => {
            ValidateVersion("login")
          })
    },[])

    useEffect(() => {
        if(resultChangePassword){
            setPassword("");
        }
    },[resultChangePassword])

    return (
        <div className='login-view'>
            {loading && <Loading overlay show />}
            <Grid>
                <Paper elevation={2} className="login-view-container-paper">
                    <div className="login-view-image">
                        <img src={logo} alt="fireSpot" />
                    </div>
                    <div className="login-view-form">
                        <Grid container justifyContent='center' style={{ marginBottom: 35 }}>
                            <Grid item xs={12} style={{ textAlign: 'center', margin: '30px 0' }}>
                                <img src={logoSecundary} style={{ width: 150 }} />
                            </Grid>
                            <div style={{ width: '100%', padding: '0 30px' }}>
                                <a
                                    type="link"
                                    className="link-social-media"
                                    style={{ background: "#ccc" }}
                                    href={`${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}oauth2/authorize?response_type=code&client_id=${endpoints.COGNITO_CLIENT_ID}&redirect_uri=${currentDomain}/login-social-media&state=STATE&identity_provider=Google`}
                                >
                                    <div id="btnSignin" className="btn-login-social-media margin-top-10 ">
                                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                                            <Grid item>
                                                <img src={google} alt="image" className="social-media-icons" />
                                            </Grid>
                                            <Grid item>
                                                <span style={{ fontSize: 14 }} className="txt-login-google">
                                                    {messages['login_sign_in_with_google']}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </a>
                            </div>
                            <div style={{ width: '100%', padding: '25px 30px 10px 30px', textAlign: 'center', fontSize: 12, fontWeight: 500 }}>
                                <span>{messages['login_sign_in_with_username']}</span>
                            </div>
                            <div style={{ width: '100%', padding: '0 30px' }}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => {
                                        handleLogin();
                                    }}
                                >
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['login_username']}
                                            placeholder={messages['login_username']}
                                            type="text"
                                            value={username}
                                            onChange={(e) => {
                                                setUsername(e);
                                            }}
                                            requiredMessage={messages['login_required_filed']}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['login_password']}
                                            placeholder={messages['login_password']}
                                            type="password"
                                            value={password}
                                            onChange={(e) => {
                                                setPassword(e);
                                            }}
                                            requiredMessage={messages['login_required_filed']}
                                        />
                                    </div>
                                    {
                                        error &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{ErrorHandlerLogin(error)}</p>
                                    }
                                    <div style={{ marginTop: 10, textAlign: 'right', fontSize: 12, cursor: 'pointer' }}>
                                        <span onClick={() => dispatch(loginForgotPasswordOpenModal(true))} >{messages['login_forgot_password']}</span>
                                    </div>
                                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                                        <Button
                                            className="btn-dark-blue"
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                formRef.current.submit();
                                            }}
                                            style={{ width: '100%' }}
                                        >
                                            {messages['login_sign_in']}
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Grid>
                    </div>
                </Paper>
            </Grid>
            <ForgotPassword />
            <ChangePassword />
        </div>
    )
}
export default LoginView;